import React, { useContext } from 'react';

import type { ByggKunde } from '@klp/messageboard/classes';
import { ByggKundeSelector } from '@klp/messageboard/components/ByggKundeSelector';

import { FormContext } from './FormContext';
import { useFormField, type IFormFieldProps } from './useFormField';

interface IFormByggKundeSelectorProps extends IFormFieldProps<
    Array<ByggKunde>
> {
    className?: string;
    id?: string;
    label?: string;
    margin?: string;
    disabled?: boolean;
}

export const FormByggKundeSelector: React.FC<IFormByggKundeSelectorProps> = (
    props,
) => {
    const { name, title, validators, value, ...rest } = props;

    const { handleChange, hasError, getHelperText, formValue } =
        useFormField<Array<ByggKunde>>(props);

    const context = useContext(FormContext);

    return (
        <ByggKundeSelector
            {...rest}
            className="Form__Field Form__Input"
            id={name}
            name={name}
            label={title}
            value={formValue || value || []}
            error={hasError()}
            onChange={handleChange(name, validators)}
            onBlur={handleChange(name, validators)}
            margin="normal"
            helperText={getHelperText()}
            disabled={context.formDisabled}
            title={title}
        />
    );
};
